/**
 * `liveVariantOf(row)` — the live rows-side row behind an SDK row's
 * `variant`.
 *
 * `SheetRow.Joined.Handle.variant` is the row's frozen reads face
 * (`ModelRowReads`): no writer, no `instanceof` against a variant class. The
 * render front-end's binding pipeline (plugin binding resolution, a
 * renderer's `loadRange`, the variant dispatch of a layout or legend) reads
 * the live variant, and takes it here — the one named step where sheets-ui
 * crosses from the face to the row (`liveRowOf`, `@tento-lona/sheets/internal-ui`).
 * A cell write goes through the SDK row's checked verbs
 * (`row.writableSingle()?.write(CellTarget.date(day), value, actor)`); the live
 * variant classes carry no writer.
 */

import type { SheetRow } from "@tento-lona";
import type { Option } from "@tento-lona/sheets";
import { type ModelRow } from "@tento-lona/sheets";
import { liveRowOf } from "@tento-lona/sheets/internal-ui";

/** The live rows-side row behind `row.variant`; `null` when the row has none. */
export function liveVariantOf(row: SheetRow.Joined.Handle): Option<ModelRow> {
  const face = row.variant;
  return face == null ? null : liveRowOf(face);
}
